import { LuRefreshCcw, LuUndo2 } from "react-icons/lu";
import RadioButtonControlGroup from "../../../../shared/RadioButtonControlGroup";
import {
    getSendTypeTabButtonId,
    QueueFilter,
    SendType,
} from "../constants";
import NotificationColumnFilterButton from "./NotificationColumnFilterButton";
import "./TopBar.scss";

const NOTIFICATIONS_SEND_TYPE_PANEL_ID = "notifications-send-type-panel";

const SEND_TYPE_TAB_OPTIONS = [
    {
        value: SendType.AUTOMATED,
        label: "Automated",
        id: getSendTypeTabButtonId(SendType.AUTOMATED),
        controls: NOTIFICATIONS_SEND_TYPE_PANEL_ID,
    },
    {
        value: SendType.MANUAL,
        label: "Manual",
        id: getSendTypeTabButtonId(SendType.MANUAL),
        controls: NOTIFICATIONS_SEND_TYPE_PANEL_ID,
    },
];

const FILTER_OPTIONS = [
    { value: QueueFilter.ALL, label: "All", tone: "default" },
    { value: QueueFilter.PENDING, label: "Pending", tone: "pending" },
    { value: QueueFilter.SENT, label: "Sent", tone: "green" },
    { value: QueueFilter.ERRORS, label: "Errors", tone: "red" },
];

/**
 * Queue toolbar: send type (Automated/Manual), All/Pending/Sent/Errors filter, reset and refresh icon buttons.
 * @param {object} props
 * @param {import("../useNotifications").UseNotificationsProps} props.useNotificationsHookData Full {@link useNotifications} bag;
 *   this bar reads `sendType`, `setSendType`, `queueFilter`, `setQueueFilter`, `columnFilters`, `resetFilters`, `refreshNotificationsList`.
 * @param {boolean} props.columnFiltersExpanded Whether the column filter builder is open above the table.
 * @param {(expanded: boolean) => void} props.setColumnFiltersExpanded Updates column filter builder visibility.
 * @returns {import('react').JSX.Element}
 */
const TopBar = ({
    useNotificationsHookData,
    columnFiltersExpanded,
    setColumnFiltersExpanded,
}) => {
    const {
        sendType,
        setSendType,
        queueFilter,
        setQueueFilter,
        columnFilters,
        resetFilters: onReset,
        refreshNotificationsList,
    } = useNotificationsHookData;

    return (
        <div className="notifications-queue__top-bar">
            <div className="notifications-queue__top-bar-left">
                <RadioButtonControlGroup
                    role="tablist"
                    ariaLabel="Notification send type"
                    value={sendType}
                    onChange={setSendType}
                    options={SEND_TYPE_TAB_OPTIONS}
                />

                <RadioButtonControlGroup
                    role="radiogroup"
                    ariaLabel="Filter notifications by status"
                    value={queueFilter}
                    onChange={setQueueFilter}
                    options={FILTER_OPTIONS}
                    minCh="7ch"
                />
            </div>

            <NotificationColumnFilterButton
                filters={columnFilters}
                expanded={columnFiltersExpanded}
                onExpandedChange={setColumnFiltersExpanded}
            />

            <div className="notifications-queue__toolbar-icon-group">
                <button
                    type="button"
                    className="notifications-queue__icon-btn"
                    aria-label="Reset Filters"
                    title="Reset filters"
                    onClick={onReset}
                >
                    <LuUndo2 aria-hidden size={18} />
                </button>
                <button
                    type="button"
                    className="notifications-queue__icon-btn"
                    aria-label="Refresh List"
                    title="Refresh list"
                    onClick={refreshNotificationsList}
                >
                    <LuRefreshCcw aria-hidden size={18} />
                </button>
            </div>
        </div>
    );
};

export default TopBar;
